import { useFormContext } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import Checkbox from "@/components/Checkbox/Checkbox";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import {
  measurementsDictionary,
  orderedMeasurementsList,
} from "@medoma/models/activities";
import type { IAddActivityFormData } from "./AddActivityForm";

export const MeasurementsPicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<IAddActivityFormData>();

  return (
    <Checkboxes
      legend={t`Värden`}
      errorMessage={errors.measurements?.message}
      orientation="horizontal"
    >
      {orderedMeasurementsList.map((measurement) => (
        <Checkbox
          key={measurement}
          label={{ text: t(measurementsDictionary[measurement]) }}
          {...register("measurements", {
            required: {
              value: true,
              message: t`Ange minst ett mätvärde`,
            },
          })}
          value={measurement}
          visualStyle="framed"
        />
      ))}
    </Checkboxes>
  );
};
